import { Box, Text } from "@mantine/core";
import { CheckIcon } from "@phosphor-icons/react";
import React from "react";
import classes from "./invoice-form-stepper.module.css";

type Props = {
  completions: boolean[];
  activeStep: number;
  stepTitles: string[];
  onStepClick: (index: number) => void;
};

export function InvoiceFormStepper({ completions, activeStep, stepTitles, onStepClick }: Props) {
  return (
    <Box className={classes.row} component="nav" aria-label="steps">
      {stepTitles.map((title, index) => {
        const done = completions[index];
        const isActive = activeStep === index;
        const state = done ? "done" : isActive ? "active" : "pending";
        const prevDone = index > 0 && completions[index - 1];
        const sepState = prevDone || activeStep >= index ? "done" : isActive ? "active" : "pending";

        return (
          <React.Fragment key={index}>
            {index > 0 ? <Box className={classes.sep} data-state={sepState} aria-hidden /> : null}
            <Box
              component="button"
              type="button"
              className={classes.chip}
              data-state={state}
              onClick={() => onStepClick(index)}
            >
              <Box component="span" className={classes.dot} data-state={state}>
                {done ? <CheckIcon size={11} weight="bold" /> : index + 1}
              </Box>
              <Text span className={classes.label} fz="sm">
                {title}
              </Text>
            </Box>
          </React.Fragment>
        );
      })}
    </Box>
  );
}
